<template>
  <v-data-table
    :loading="loading"
    :headers="getHeaders"
    :items="getSales"
    :mobile-breakpoint="0"
    :hide-default-header="$vuetify.breakpoint.xsOnly"
    hide-default-footer
    :items-per-page="$vuetify.breakpoint.xsOnly ? 8 : 10"
    @page-count="pageCount = $event"
    :page.sync="page"
    :search="search"
    sort-by="date"
    :sort-desc="true"
  >
    <template v-slot:top>
      <v-row align="center" justify="end">
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <SalesEditor :id="item.id"></SalesEditor>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import SalesEditor from "./SalesEditor";
export default {
  name: "SalesGrid",
  components: {
    SalesEditor
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getSales"]),
    getHeaders() {
      if (this.$vuetify.breakpoint.xsOnly) {
        return [
          {
            value: "date",
            sortable: true,
            sortDirection: "desc"
          },
          { value: "value_before_tx" },
          { value: "actions", sortable: false }
        ];
      } else {
        return [
          {
            value: "date",
            text: "Date",
            sortable: true,
            sortDirection: "desc"
          },
          { value: "value_before_tx", text: "Avant Taxe" },
          { value: "tps", text: "Tps" },
          { value: "tvq", text: "Tvq" },
          { value: "value_after_tx", text: "Après Taxe" },
          { text: "", value: "actions", sortable: false }
        ];
      }
    }
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      search: ""
    };
  }
};
</script>

<style></style>
